var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v(" Vytvorenie hypotéky ")])]), _c('div', {
    staticClass: "input-block"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'property_pravny_stav',
      "init-value": _vm.mortgagePurposes[0].value,
      "options": _vm.mortgagePurposes,
      "normal": "",
      "name": 'Účel hypotéky'
    },
    on: {
      "select": function select($event) {
        _vm.pickedMortgagePurpose = $event;
      }
    }
  })], 1), _c('client-picker', {
    attrs: {
      "disabled": _vm.saving,
      "complex": ""
    },
    on: {
      "client-picked": function clientPicked($event) {
        _vm.selectedClient = $event;
      },
      "busy": function busy($event) {
        _vm.clientBusy = $event;
      }
    }
  }), _vm.saveError ? _c('p', {
    staticClass: "clientError",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.saveError))]) : _vm._e(), _c('button', {
    staticClass: "w-button",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedClient || _vm.saving || _vm.clientBusy
    },
    on: {
      "click": function click($event) {
        return _vm.createMortgageToClient(_vm.selectedClient);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.saving ? 'Vytváram…' : 'Vytvoriť hypotéku') + " ")])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }